import {Trans} from '@lingui/macro';
import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {PaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/paletteModel';
import {useRuleEditorContext} from '../../editors/ruleEditor/ruleEditorContext';

/*
 * Types.
 */

interface RuleEditorSectionProps {
  description: ReactNode;
  shouldShowMoreOptions?: boolean;
  toggleMoreOptions?: Handler;
}

/*
 * Styles.
 */

const RuleEditorSectionWrap = styled.div`
  margin-bottom: 25px;
  display: grid;
  grid-row-gap: 10px;
`;

const RuleEditorSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const RuleEditorSectionDescription = styled.div`
  font-size: ${fontSizes.veryLarge};
  font-weight: ${fontWeights.semibold};
`;

const RuleEditorSectionContent = styled.div``;

/*
 * Component.
 */

export const RuleEditorSection: FC<RuleEditorSectionProps> = (props) => {
  const {description, children, shouldShowMoreOptions, toggleMoreOptions} = props;
  const {isLibrary} = useRuleEditorContext();

  return (
    <RuleEditorSectionWrap>
      <RuleEditorSectionHeader>
        <RuleEditorSectionDescription>{description}</RuleEditorSectionDescription>
        {isLibrary && toggleMoreOptions && (
          <Button
            variant={ButtonVariantsEnum.LINK}
            size={VisualSizesEnum.SMALL}
            color={PaletteColorsEnum.GREY}
            onClick={toggleMoreOptions}
          >
            {shouldShowMoreOptions ? (
              <Trans id="rules-section-header-fewer-options">Fewer options</Trans>
            ) : (
              <Trans id="rules-section-header-more-options">More options</Trans>
            )}
          </Button>
        )}
      </RuleEditorSectionHeader>
      <RuleEditorSectionContent>{children}</RuleEditorSectionContent>
    </RuleEditorSectionWrap>
  );
};
